export type TProgressBreakpoint = 0 | 25 | 50 | 75 | 100;

export const PERCENT_BREAKPOINTS: TProgressBreakpoint[] = [0, 25, 50, 75, 100];
